import {csrfToken} from "../../../../vite/src/utils";

App.namespace('views.cabinet.publish_unpublish_room', () => {
  let $unpublishRoomModalConfirm;

  const sendRequest = (url) => {
    const csrfToken = $.fn.findOneInDocument('meta[name=csrf-token]').attr('content');

    $.redirectPost(url, {
      _token: csrfToken,
    }, 'POST');
  };

  const displayModal = (modal) => {
    modal.find('.ds-modal-wrapper').addClass('ds-modal-wrapper--visible');
    modal.find('.ds-modal-overlay').addClass('ds-modal-overlay--visible');
    modal.find('.ds-modal-actions button.ds-button').off('click').on('click', e => {
      // got it
      e.preventDefault();
      modal.find('.ds-modal-wrapper').removeClass('ds-modal-wrapper--visible');
      modal.find('.ds-modal-overlay').removeClass('ds-modal-overlay--visible');
    });
  };

  const changeStatusWithPrompt = (url, status) => {
    if (status === 'draft' || status === 'unpublished') {
      sendRequest(url);
      return;
    }

    $unpublishRoomModalConfirm.find('.ds-modal-wrapper').addClass('ds-modal-wrapper--visible');
    $unpublishRoomModalConfirm.find('.ds-modal-overlay').addClass('ds-modal-overlay--visible');
    $unpublishRoomModalConfirm.find('.ds-modal-actions button.ds-button--red').off('click').on('click', e => {
      // confirm
      e.preventDefault();
      unpublishRoom();
    });
  };

  const unpublishRoom = () => {
    $.ajax({
      url: window.JS_UNPUBLISH_AJAX_URL,
      type: 'POST',
      data: {
        _token: csrfToken(),
      },
      success(response) {
        if (response.status) {
          window.location.reload();
        }
      },
      error(err) {
        $unpublishRoomModalConfirm.find('.ds-modal-wrapper').removeClass('ds-modal-wrapper--visible');
        $unpublishRoomModalConfirm.find('.ds-modal-overlay').removeClass('ds-modal-overlay--visible');

        if (err.responseJSON.errors?.general[0] === 'You cannot unpublish a space with active enquiries. Please, finalize your enquiries first, and then try again.') {
          displayModal($('#js-unpublish-active-rfps'));
        } else {
          displayModal($('#js-unpublish-last-room-modal'));
        }
      },
    });
  }

  const onClick = (event) => {
    const $parent = $(event.target).parent();
    const status = $parent.data('room-status');
    const url = $parent.data('room-url');

    if (!url || !status) {
      throw new Error(`Invalid parameters, got url: ${url}, status: ${status}`);
    }

    changeStatusWithPrompt(url, status);
  };

  return {
    bindToButtons($elements) {
      $elements.each((i, element) => {
        $(element).on('click', onClick);
      });

      $unpublishRoomModalConfirm = $('#js-unpublish-room-modal-confirm');
      $unpublishRoomModalConfirm.find('.ds-modal-actions button.ds-button--white, .ds-modal-wrapper, .ds-modal__close_button').click(e => {
        // close
        e.preventDefault();
        $unpublishRoomModalConfirm.find('.ds-modal-wrapper').removeClass('ds-modal-wrapper--visible');
        $unpublishRoomModalConfirm.find('.ds-modal-overlay').removeClass('ds-modal-overlay--visible');
      });
      $unpublishRoomModalConfirm.find('.ds-modal').click(e => {
        e.stopPropagation();
      });
    },
    changeStatusWithPrompt,
  };
});
